import { useState } from "react";

import { Cart, Customer, Space } from "@prisma/client";
import { Form, useFetcher } from "@remix-run/react";
import dayjs from "dayjs";

import { Button, CountDownTimer, DialogHeader, DialogTitle, Modal } from "~/components";
import { ShareSpace } from "~/components/shared/ShareSpace";
import { SpaceCard } from "~/components/shared/Space";
import { HeartIcon, ShareIcon } from "~/icons";

export function SelectedSpace({
    space,
    baseUrl,
    customer,
    withAuthKit,
    cart,
}: {
    space: Space;
    baseUrl: string;
    customer: Customer;
    withAuthKit: boolean;
    cart: Cart;
}) {
    const [isOpen, setIsOpen] = useState(false);

    const isFavorited = customer?.favorites?.includes(space?.lotSellUnitId);
    const fetcher = useFetcher();

    return (
        <SpaceCard space={space}>
            <Form method="post" className="mt-4">
                <div className="flex flex-col md:flex-row gap-4">
                    <Button className="flex-1 flex gap-2" variant="outline" onClick={() => setIsOpen(true)}>
                        <ShareIcon className="w-4 h-4" />
                        <h2>Share</h2>
                    </Button>
                    <div className="flex-1 flex gap-4 w-full justify-center">
                        <input name="lotSellUnitId" value={space.lotSellUnitId} type="hidden" />
                        <Button
                            disabled={dayjs().isBefore(space.lockedUntil)}
                            name="intent"
                            value="add-to-cart"
                            type="submit"
                            className="w-full uppercase"
                        >
                            Add to cart
                        </Button>
                    </div>
                </div>
            </Form>
            <div className="mt-6 flex flex-col md:flex-row-reverse justify-between items-start gap-4 md:gap-8">
                <section className="">
                    <Modal open={isOpen} onOpenChange={() => setIsOpen(false)} triggerButton={false}>
                        <DialogHeader>
                            <DialogTitle>Share this memorial space</DialogTitle>
                        </DialogHeader>
                        <ShareSpace baseUrl={baseUrl} space={space} />
                    </Modal>
                    {withAuthKit && (
                        <fetcher.Form method="post" action="/favorites">
                            <input name="lotSellUnitId" value={space.lotSellUnitId} type="hidden" />
                            <input name="action" value={isFavorited ? "remove" : "add"} type="hidden" />
                            <Button
                                className={`-mt-2 flex gap-2  ${isFavorited && "text-destructive hover:text-destructive"}`}
                                name="intent"
                                value="save-space-to-favorites"
                                variant="ghost"
                                type="submit"
                            >
                                <HeartIcon className="w-5 h-5" />
                                <h2>{isFavorited ? "Remove favorite" : "Save for later"}</h2>
                            </Button>
                        </fetcher.Form>
                    )}
                </section>

                <CountDownTimer space={space} cart={cart} />
            </div>
        </SpaceCard>
    );
}
